import $ from 'jquery';
// export for others scripts to use
window.jQuery = $;
window.jquery = $;
window.$ = $;
import whatInput from 'what-input';
import Foundation from 'foundation-sites';
import Swiper, { Navigation, Pagination, Autoplay, Thumbs } from 'swiper';

import 'fouc.js';
import 'cookie-consent.js';
//import 'sticksy';

document.addEventListener('DOMContentLoaded', function(event) {
	
	// Foundation
	jQuery(document).foundation();
	
	// configure Swiper modules
	Swiper.use([Navigation, Pagination, Autoplay, Thumbs]);
	
	// Hamburguer menu
	const headerElements = {
		hamburguer: document.querySelector('.menu-toggle'),
		//logo: document.querySelector('.site-title'),
		userCart: document.querySelector('.user-cart-menu'),
		menu: document.querySelector('.main-navigation')
	}
	
	headerElements.hamburguer.onclick = function() {
  	// Looping through headerElements object	
		const singleHeaderElement = Object.keys(headerElements)
		for (let value of singleHeaderElement) {
			headerElements[value].classList.toggle("is-active");
		}
	}
	
	// Add class on scroll up. Remove on scroll down. Also add another class on scroll amount of pixels
	var lastScrollTop = 0;
	window.onscroll = function changeClass(){
		var st = window.pageYOffset || document.documentElement.scrollTop,
			mastHead = document.querySelector("#masthead");
		
		if (st > lastScrollTop && st > 180){
			mastHead.classList.add("hide-header");
		  
		} else {
			mastHead.classList.remove("hide-header");
		  
		}
		
		lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
	};
	
	// Swiper Store notice
	var swiper = new Swiper(".swiper-store-notice", {
		loop: true,
		autoplay: {
			delay: 3500,
			disableOnInteraction: false,
		}
	});
  
	// Swiper Home header
	var headerSwiper = new Swiper(".header-slider", {
		loop: true,
		autoplay: {
			delay: 4000,
			disableOnInteraction: false
		},
		navigation: {
			nextEl: ".swiper-button-next",
			prevEl: ".swiper-button-prev"
		}
	});
  
	// Single product gallery
	var swiperSingleProduct = new Swiper(".swiper-product", {
		slidesPerView: 1,
		pagination: {
			el: '.swiper-product__pagination',
			clickable: true
		},
		autoplay: {
			delay: 4000,
			disableOnInteraction: false
		},
		breakpoints: {
			
			1024: {
				allowSlideNext: false,
				pagination: false,
				autoplay: false,
				slidesPerView: 2,
				grid: {
					rows: 5
				}
			}
		}
	});
	
	//if ( window.innerWidth >= 1024 ) {
	//	swiperSingleProduct.destroy(true, true);
	//}
  
});
